/**
 * auth：hss
 * time：2020.03.13
 * des：主应用传递给子应用的 用于emit触发主应用事件的函数
 */

import store from '@/store';

function changeCurrentPath (pathArr) {
    store.dispatch('menu/setCurrentPath', pathArr);
}

function changeSelectMenu (menuId) {
    store.dispatch('menu/setSelectedMenuId', menuId);
}

function changeSchoolFrom (from) {
    store.dispatch('user/setSchoolFrom', from);
}
export {
    changeCurrentPath,
    changeSelectMenu,
    changeSchoolFrom
};